import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { useUserStore } from '@/hooks/use-user-store';
import { useBonusEngineClient, userPromosKeys } from '@/providers';
import { useQuery } from '@tanstack/react-query';

import { BonusEnginePromo, PromoStatus } from '../types';
import { PROMOS_CACHE_TIME } from '../utils/promotions-utils';

export const useSegmentedPromos = ({ status, enabled }: { status?: PromoStatus; enabled: boolean }) => {
    const userId = useUserStore(state => state.profile.sub);
    const activeProduct = useJurisdictionStore(state => state.product);
    const bonusEngineAPIClient = useBonusEngineClient();

    const endpoint = `/users/${userId}/promotions?productType=${activeProduct.toUpperCase()}${
        status ? `&status=${status}` : ''
    }`;

    return useQuery<BonusEnginePromo[]>({
        queryKey: userPromosKeys.segmentedPromotions(userId, activeProduct),
        queryFn: () =>
            bonusEngineAPIClient.fetch(endpoint).then(it => {
                return it?.promotionsInfo ?? [];
            }),
        enabled,
        staleTime: PROMOS_CACHE_TIME,
    });
};
